import React, { useContext, useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { useTheme } from "styled-components";
import { Button, Container, Inner } from "./styles";
import Icon from "../Icon";
import ClosableTag from "../ClosableTag";
import { HoveredFilterContext, SearchContext } from "../../context";
import AggregateView from "../AggregateView";
import { SEARCH_CHIP_CONFIG, SEARCH_MODES } from "../SearchInput/constants";
import { ENTITY_BY_FILTER_NAME } from "../../constants/entityTypes";

const SearchFilters = props => {
  const theme = useTheme();
  const search = useContext(SearchContext);
  const { hoveredFilter } = useContext(HoveredFilterContext);
  const [showMore, toggleShowMore] = useState(false);
  const [heightBreakPoint, setBreakPoint] = useState(48);
  const [height, setHeight] = useState(0);

  const tagsContainer = useRef(null);

  const tagsContainerHeight =
    tagsContainer.current && tagsContainer.current.getBoundingClientRect();

  useEffect(() => {
    if (tagsContainer.current) {
      const height = tagsContainer.current.getBoundingClientRect().height;
      setHeight(height);
    }
  }, [tagsContainerHeight]);

  useEffect(() => {
    if (!showMore && tagsContainer.current) {
      tagsContainer.current.scrollTo(0, 0); //TODO: not working for some reason
    }
  }, [showMore]);

  useEffect(() => {
    if (props.mobileView)
      setBreakPoint(parseInt(theme.mobileFilterBarHeight, 10));
  }, [props.mobileView, theme.mobileFilterBarHeight]);

  return (
    <>
      <Container
        mobileView={props.mobileView}
        heightBreakPoint={heightBreakPoint}
      >
        <Inner
          mobileView={props.mobileView}
          containerHeight={height}
          showMore={showMore}
          heightBreakPoint={heightBreakPoint}
          onMouseLeave={
            props.mobileView
              ? () => { }
              : () => {
                tagsContainer.current.scrollTo(0, 0); //TODO: not working for some reason

                toggleShowMore(false);
              }
          }
          onMouseEnter={
            props.mobileView
              ? () => { }
              : () => {
                toggleShowMore(true);
              }
          }
        >
          <div className={`selected-tags `} ref={tagsContainer}>
            {props.mobileView && !props.static && (
              <Button
                style={{
                  width: 98,
                  height: 24,
                  marginRight: 15,
                  marginBottom: 10
                }}
                onClick={search.openFilterDrawer}
              >
                <Icon
                  type="add"
                  size="xxs"
                  className="icon"
                  label="add-filter"
                />
                <p className="p4b">Add Filter</p>
              </Button>
            )}
            {search.selectedAggregates.length !== 0 &&
              search.selectedAggregates.map((item, i) => {
                return <AggregateView key={i} aggregate={item} />;
              })}
            {search.uploadedTrack?.status === "analyzed" && (
              <div className="filter">
                <ClosableTag
                  onSearchFilter={true}
                  isEntityTag={true}
                  isActive={true}
                  range={[1, 5]}
                  hasRange={false}
                  text={search.uploadedTrack.filename}
                  icon="similar_tracks"
                  background={theme.primary}
                  onClose={() =>
                    search.setUploadedTrack({
                      status: "idle",
                      filename: null
                    })
                  }
                />
              </div>
            )}
            {search.searchFilters
              .filter(item => !item.aggregate)
              .map(item => {
                if (item.hidden) return null;
                if (item.filterType === "range") {
                  return (
                    <div className="filter" key={item.filterName}>
                      <ClosableTag
                        onSearchFilter={true}
                        onClose={() => {
                          search.removeFilter(item.filterName, "range");
                        }}
                        range={[item.min, item.max]}
                        text={item.filterName}
                        minWidth="110px"
                        minHeight={props.mobileView ? 20 : null}
                        isActive={true}
                        background={
                          item.filterName.toLowerCase() === "duration" ||
                            item.filterName === "Length" ||
                            item.filterName === "BPM"
                            ? theme.primary
                            : theme.backgroundLighter
                        }
                      />
                    </div>
                  );
                }
                if (item.filterType === "dateRange") {
                  return (
                    <div className="filter" key={item.filterName}>
                      <ClosableTag
                        onSearchFilter={true}
                        onClose={() => {
                          search.removeFilter(item.filterName, "dateRange");
                        }}
                        width="auto"
                        range={[1, 5]}
                        text={item.filterName}
                        isActive={true}
                      />
                    </div>
                  );
                }

                return (
                  <div className="filter" key={item.filterValue}>
                    <ClosableTag
                      onSearchFilter={true}
                      isEntityTag={!!ENTITY_BY_FILTER_NAME[item.filterName]}
                      onClose={() => {
                        // Entity chip -> atomic exit (restores the browse filter
                        // snapshot, dropping this chip AND any within-entity
                        // filters, then reloads browse)
                        if (ENTITY_BY_FILTER_NAME[item.filterName]) {
                          search.exitEntityToBrowse();
                        } else {
                          // non-entity chip -> just remove that one filter
                          search.removeFilter(item.filterValue, "selectable");
                        }
                      }}
                      range={[1, 5]}
                      isActive={true}
                      isKey={item.filterName === "key"}
                      text={item.filterValue}
                      icon={
                        ENTITY_BY_FILTER_NAME[item.filterName]?.typename ===
                          "Track" &&
                          search.searchMode === SEARCH_MODES.SIMILARITY
                          ? "similar_tracks"
                          : ENTITY_BY_FILTER_NAME[item.filterName]?.typename ===
                            "Track" &&
                            search.selectedTrackList?.entity?.variationTitle
                            ? "variation"
                            : ENTITY_BY_FILTER_NAME[item.filterName]?.iconName ??
                            SEARCH_CHIP_CONFIG[item.filterName]?.iconName
                      }
                    />
                  </div>
                );
              })}

            {hoveredFilter &&
              (hoveredFilter.filterType === "range" ||
                hoveredFilter.filterType === "dateRange") ? (
              <div className="filter">
                <ClosableTag
                  faded={true}
                  onClose={() => { }}
                  range={[hoveredFilter.min, hoveredFilter.max]}
                  text={hoveredFilter.filterName}
                  minWidth={
                    hoveredFilter.filterType === "range"
                      ? "110px"
                      : "93px"
                  }
                  minHeight={props.mobileView ? 20 : null}
                  isActive={true}
                  background={
                    hoveredFilter.filterName === "Length" ||
                      hoveredFilter.filterName === "BPM"
                      ? "#6E70B0"
                      : "#363636"
                  }
                />
              </div>
            ) : (
              hoveredFilter && (
                <div className="filter">
                  <ClosableTag
                    onClose={() => { }}
                    range={[1, 5]}
                    isActive={true}
                    text={hoveredFilter.filterValue}
                    faded={true}
                    isKey={
                      hoveredFilter.filterName.toLowerCase() === "key"
                    }
                  />
                </div>
              )
            )}
          </div>
          {height > heightBreakPoint + 1 && (
            <div
              onMouseLeave={
                props.mobileView
                  ? () => { }
                  : () => {
                    toggleShowMore(false);
                  }
              }
              onMouseEnter={
                props.mobileView
                  ? () => { }
                  : () => {
                    toggleShowMore(true);
                  }
              }
              onClick={
                props.mobileView
                  ? () => toggleShowMore(prev => !prev)
                  : () => { }
              }
              className="more-icon-container"
            >
              <Icon
                type="triangle"
                size="sm"
                className="more-icon"
                label="toggle-filters"
                style={{
                  transform: showMore
                    ? "scale(0.75) rotate(0deg)"
                    : "scale(0.75) rotate(180deg)",
                  transition: "transform 0.25s ease"
                }}
              />
            </div>
          )}
        </Inner>
      </Container>
    </>
  );
};

export default withRouter(SearchFilters);
